import request from '@/plugins/axios'

export function checkHealth() {
  return request({
    url: 'pan/health',
    method: 'get'
  })
}

export function searchNetDisk(keyword, params) {
  return request({
    url: 'pan/search',
    method: 'get',
    params: {
      kw: keyword,
      cloud_types: 'baidu,aliyun,quark,magnet,xunlei',
      ...params
    }
  })
}